import axiosInstance from "./common";

export default class AnnotationService {
    static async saveAnnotation(itemId, annotation) {
        const response = await axiosInstance.post(`/item/${itemId}/annotation`, annotation)

        return response
    }
}